import styled from 'styled-components';

import { colors } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const LegacySecondaryButtonDanger = styled(ButtonWithStyles)`
  color: ${colors.white};
  background-color: ${colors.scarlet};
  border: 1px solid ${colors.scarlet};

  &:hover,
  &:focus {
    background-color: ${colors.brick};
    border-color: ${colors.brick};
    color: ${colors.white};
    text-decoration: none;
  }
`;
